import { render, staticRenderFns } from "./add-users-modal.vue?vue&type=template&id=156aea0b&scoped=true"
import script from "./add-users-modal.vue?vue&type=script&lang=js"
export * from "./add-users-modal.vue?vue&type=script&lang=js"
import style0 from "./add-users-modal.vue?vue&type=style&index=0&id=156aea0b&prod&lang=scss&scoped=true"
import style1 from "./add-users-modal.vue?vue&type=style&index=1&id=156aea0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "156aea0b",
  null
  
)

export default component.exports